import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  agentConf: {},
  campConf: {},
  facilityConf: {},
  features: {},
  newFeatures: {},
  timezone: {},
  countryCodes: {},
  activeLists: {},
  searchParameter: '',
  error: null,
  loading: false,
};

const agentConfigStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentConfigSuccess = (state, action) => {
  return updateObject(state, {
    agentConf: action.agentConf,
    campConf: action.campConf,
    facilityConf: action.facilityConf,
    features: action.features,
    newFeatures: action.newFeatures,
    timezone: action.timezone,
    countryCodes: action.countryCodes,
    activeLists: action.activeLists,
    searchParameter: action.searchParameter,
    loading: false,
  });
};

const agentConfigFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_CONFIG_START:
      return agentConfigStart(state, action);
    case actionTypes.AGENT_CONFIG_SUCCESS:
      return agentConfigSuccess(state, action);
    case actionTypes.AGENT_CONFIG_FAIL:
      return agentConfigFail(state, action);
    default:
      return state;
  }
};

export default reducer;
